<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" style="height:cal( 100% - 100px )" v-if="addType">
        <div class="backBox">
          <button class="btn btn-back" @click="closeSub">返回</button>
        </div>
        <div class="write-txt" :class="addType=='edit'?'noPointer':''">
          <p class="write-title">选择类型：<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.type" placeholder="请选择"  @change="Getgrade">
              <el-option
                v-for="item in typelist"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="write-txt" :class="addType=='edit'?'noPointer':''">
          <p class="write-title">年级学期：<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.grade_id" placeholder="请选择">
              <el-option
                v-for="item in gradeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">资源包名称：<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="" v-model="addObj.name"></textarea>
          </div>
        </div>

        <div class="write-txt" :class="addType=='edit'?'noPointer':''">
          <p class="write-title">地区：<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.area" placeholder="请选择">
              <el-option
                v-for="item in areaList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        
        <div class="write-txt">
          <p class="write-title">上传图片：<span>*</span></p>
          <div class="write-text">
            <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="addObj.image">
              <img :src="'https://pic.yuwenjl.com/'+addObj.image" alt="">
              <div class="hover" v-if="imgType">
                <i class="icon-delete" @click="imgRemove"></i>
              </div>
            </div>
            <el-upload
              :action="'https://upload.qiniup.com'"
              :data="uploadObj"
              list-type="picture-card"
              :before-upload="beforeUploadImg"
              :on-success="handleSuccessImg"
              :on-progress="handleProgressImg"
              :on-remove="handleRemoveImg"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img
                width="100%"
                :src="'https://pic.yuwenjl.com/' + addObj.image"
                alt=""
              />
            </el-dialog>
          </div>
        </div>  

        <div class="write-txt">
          <p class="write-title">排序：<span>*</span></p>
          <div class="write-text">
            <input type="number" v-model="addObj.sort">
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      <div class="MobelBox reviewBox" v-else-if="reviewType">
        <div class="backBox">
          <button class="btn btn-back" @click="closeSub">返回</button>
        </div>
        <div class="write-txt" v-for="(item,index) in reviewList" :key="index">
          <p class="write-title">复习周期规律：<span>*</span></p>
          <div class="write-text">
            每
            <input type="number" class="num" v-model="item.num" @change="$forceUpdate()">
            <el-radio-group v-model="item.type" style="display: inline-block;vertical-align: middle;">
              <el-radio label="d">天</el-radio>
              <el-radio label="m">月</el-radio>
              <el-radio label="y">年</el-radio>
            </el-radio-group>
              <button class="btn btn-review-remove" v-if="index>0" @click="removeReviewType(index)">删除</button>
          </div>
        </div>

        <button class="btn btn-add" @click="addReview">+添加周期</button>



        <div class="write-btnBox">
          <button class="btn btn-save" @click="reviewSub">保存</button>
          <button class="btn btn-close" @click="reviewHide">取消</button>
        </div>
      </div>

      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <p>添加资源包</p>
          </div>
          <div class="searchBox clear hide">
            <div class="search-item">
              <p>类型：</p>
              <el-select v-model="obj.type" placeholder="请选择" >
                <el-option
                  v-for="item in typelist"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
          <div class="searchBox clear">
            <div class="search-item name">
              <p>资源包名称：</p>
              <input type="text" placeholder="请输入要搜索的资源包名称" v-model="obj.name">
            </div>
            <div class="search-item">
              <p>状态：</p>
              <el-select v-model="obj.status" placeholder="请选择">
                <el-option key="0" label="关闭" value="0"></el-option>
                <el-option key="1" label="开启" value="1"></el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>排序：</p>
              <el-select v-model="obj.sort" placeholder="请选择">
                <el-option key="1" label="正序" value="asc"></el-option>
                <el-option key="2" label="倒序" value="desc"></el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>创建时间：</p>
              <el-select v-model="obj.create_time" placeholder="请选择">
                <el-option key="1" label="正序" value="asc"></el-option>
                <el-option key="2" label="倒序" value="desc"></el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <p class="list-title">资源包列表</p>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.count">{{item.count}}</p> 
              <p :title="item.type==1?'实词/虚词':item.type==2?'古诗词':'现代文阅读'">{{item.type==1?'实词/虚词':item.type==2?'古诗词':'现代文阅读'}}</p>
              <p :title="item.area==1?'全国':'上海'">{{item.area==1?'全国':'上海'}}</p>
              <p :title="item.sort">{{item.sort}}</p>
              <p >
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.status"
                  active-color="#00C7A3"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p class="btnList">
                <button title="编辑" class="btn btn-revise" @click="buildSub(item)">编辑</button>
                <button title="删除" style="color: #FF1919;" class="btn btn-remove" @click="removeShow(item)">删除</button>
                <button title="内容设置" v-if="item.type!=4" class="btn btn-revise" @click="glossarySub(item)">内容设置</button>
                <button title="复习设置" v-if="item.type!=4" class="btn btn-revise" @click="reviewShow(item)">复习设置</button>

                <button title="考点定位" v-if="item.type==4" class="btn btn-revise" @click="glossarySub(item,1)">考点定位</button>
                <button title="标答拆解" v-if="item.type==4" class="btn btn-revise" @click="glossarySub(item,2)">标答拆解</button>
                <button title="步骤逆推" v-if="item.type==4" class="btn btn-revise" @click="glossarySub(item,3)">步骤逆推</button>
                <button title="反向解题" v-if="item.type==4" class="btn btn-revise" @click="glossarySub(item,4)">反向解题</button>


              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="removeHide">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPackageList,savePackage ,getPackageDetail,delPackage ,updatePackageStatus,getResourceIphoneList ,getUploadToken,getGradeAllList,PackageSaveReview} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "resource",
  data() {
    return {
      navId:'3',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'资源包名称'},
        {id:3,title:'词数量'},
        {id:4,title:'类型'},
        {id:5,title:'地区'},
        {id:6,title:'排序'},
        {id:7,title:'开启/关闭'},
        {id:8,title:'添加时间'},
        {id:9,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        name:'',
        type:1,
        grade_id:'',
        area:1,
        image:'',
        sort:'',
      },
      vip_date:'d',
      totalPage:0,
      removeID:'',
      url:'',
      vipList:[],
      libList:[],
      typelist:[
        {id:1,title:'实词/虚词'},
        {id:2,title:'古诗文'},
        {id:4,title:'现代文阅读'},
      ],
      areaList:[
        {id:1,title:'全国'},
        {id:2,title:'上海'},
      ],
      imgType:false,
      uploadObj: {
        token: "",
        key: "",
      },
      dialogVisible:false,
      gradeList:[],
      reviewObj:{
        lid:'',
        review:[]
      },
      reviewList:[
        {num:'',type:''}
      ],
      reviewType:false
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
    this.getToken();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.obj,this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token;   
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
      };
      this.addObj = {
        name:'',
        type:1,
        grade_id:'',
        area:1,
        image:'',
        sort:'',
      };
      this.vip_date = 'd'
      this.dataList = [];
      this.getList();
    },

    async getVipList(){
      var that = this;
      try {
        const response = await getResourceIphoneList(this.token);
        if(response.code == 200){
          that.vipList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getlibList(){
      var that = this;
      try {
        const response = await getAllPackageList(this.token);
        if(response.code == 200){
          that.libList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getList(){
      var that = this;
      try {
        const response = await getPackageList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.status==0){
              item.status=false
            } else {
              item.status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
      this.Getgrade();
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getPackageDetail({lid:e.lid},this.token);
        if(response.code == 200){
          that.addObj = response.data;
          that.Getgrade();
          that.addType = 'edit';
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.lid;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delPackage({lid:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.removeType = false;
          that.removeID = '';
          that.getList();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeHide(){
      var that = this;
      that.removeType = false;
      that.removeID = '';
    },

    async saveSub(){
      var that = this;
      if(this.addObj.name == ''){
        that.$message('请输入资源包名称！');
        return false;
      }
      if(this.addObj.grade_id == ''){
        that.$message('请选择年级学期！');
        return false;
      }
      if(this.addObj.area == ''){
        that.$message('请选择地区！');
        return false;
      }
      if(this.addObj.image == ''){
        that.$message('请上传封面！');
        return false;
      }
      if(this.addObj.sort == ''){
        that.$message('请填写排序！');
        return false;
      }
      try {
        const response = await savePackage(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async switchChange(e){
      var that = this;
      var obj = {
        lid:e.lid,
        status:e.status==false?0:1,
      };
      try {
        const response = await updatePackageStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.status = !e.status;
        }
      } catch (error) {
        that.$message(error);
        e.status = !e.status;
      }
    },

    async Getgrade(){
      var that = this;
      try {
        const response = await getGradeAllList({type:this.addObj.type},this.token);
        if(response.code == 200){
          that.gradeList = response.data;
          console.log(that.gradeList,'=ddddd==')
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    

    closeSub(){
      this.addType = '';
      this.addObj = {
        name:'',
        type:1,
        grade_id:'',
        area:1,
        image:'',
        sort:'',
      };
      this.vip_date = 'd';
      this.reviewObj={
        lid:'',
        review:[]
      },
      this.reviewList=[
        {num:'',type:''}
      ],
      this.reviewType=false;
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    beforeUploadImg(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessImg(response, file, fileList,index,type,num) {
      var that = this;
      that.addObj.image = response.key;
      that.$forceUpdate();
      that.loading = false;
      that.uploadObj.key = "";
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveImg() {
      this.uploadUrl = "";
      this.addObj.image = "";
    },
    

    async reviewShow(e){
      var that = this;
      this.reviewObj.lid = e.lid;
      try {
        const response = await getPackageDetail({lid:e.lid},this.token);
        if(response.code == 200){
          if(response.data.review){
            var data = JSON.parse(JSON.stringify(response.data.review))
            that.reviewList = [];
            data.forEach(function(item,index){
              if(item.indexOf('d') > -1){
                that.reviewList.push({num:item.split('d')[0],type:'d'})
              }
              if(item.indexOf('m') > -1){
                that.reviewList.push({num:item.split('m')[0],type:'m'})
              }
              if(item.indexOf('y') > -1){
                that.reviewList.push({num:item.split('y')[0],type:'y'})
              }
            });
          } else {
            that.reviewList = [
              {num:'',type:''}
            ];
          }
          that.reviewType = true;
          console.log(that.reviewList,'1')
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addReview(){
      this.reviewList.push({num:'',type:''});
      console.log(this.reviewList,'2')
      this.$forceUpdate();
    },

    removeReviewType(index){
      this.reviewList.splice(index,1);
      console.log(this.reviewList,'3');
      this.$forceUpdate();
    },

    async reviewSub(){
      var that = this;
      console.log(this.reviewList,'reviewList4')
      that.reviewObj.review = [];
      this.reviewList.forEach(function(item,index){
        that.reviewObj.review.push(item.num+item.type)
      });
      console.log(this.reviewObj,'reviewObj')
      try {
        const response = await PackageSaveReview(this.reviewObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();     
          that.reviewType = false;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    reviewHide(){
      this.reviewList = [
        {num:'',type:''}
      ];
      this.reviewType = false;
    },

    glossarySub(e,i){
      if(e.type == 4){
        this.$router.push('/read?lid='+e.lid+'&type='+e.type + '&step='+i);
      } else {
        this.$router.push('/glossary?lid='+e.lid+'&type='+e.type);
      }
    }
  }

  
};
</script>
<style scoped>
  .search-item.name input{
    width: 240px;
  }

  .search-item>>> input{
    width: 147px;
    border: solid 1px #333333;
  }

  .el-select-dropdown__item.selected{
    color: #333333;
  }

  .el-select-dropdown__item.hover{
    background-color: #00C7A3;
    color: #fff;
  }

  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 9 );
    padding: 21px 10px;
  }

  .dataList .listItem p.btnList{
    font-size: 0;
  }

  .btnList .btn{
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    color: #333333;
    margin: 0 0 7px 0;
    width: 50%;
    text-align: left;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .write-btnBox .btn{
    width: 145px;
    height: 51px;
    line-height: 51px;
    border-radius: 8px;
    color: #fff;
    background-color: #00C7A3;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 80px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.write-txt>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.write-txt>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.reviewBox .write-text input,
.write-txt>>> .el-radio-group{
  display: inline-block;
  vertical-align: middle;
}

.content>>> .el-radio__input.is-checked .el-radio__inner{
  background-color: #00C7A3;
  border-color: #00C7A3;
}
.content>>> .el-radio__input.is-checked+.el-radio__label{
  color: #00C7A3;
}
.content>>> .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #00C7A3;
}

.reviewBox .write-text input{
  margin-right: 20px;
}

.reviewBox .btn-add{
  font-size: 18px;
  color: #00C7A3;
  border-radius: 6px;
  padding: 6px 24px;
  box-sizing: border-box;
  display: block;
  margin-top: 37px;
  border: solid 1px #00C7A3;
}


.MobelBox .write-text .btn.btn-review-remove{
  color: #fff;
  font-size: 18px;
  background-color: #F26060;
  border-radius: 6px;
  height: 36px;
  line-height: 36px;
  margin-left: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 36px;
  display: inline-block;
  vertical-align: top;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pack/list.vue